import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AppState,
  FrameToComeActionTypes,
  selectFrameToCome,
  MyNotificationsActionTypes,
  selectProfile,
  selectFrameToComeCart,
  selectFrameToComeOrder,
} from '@app/core/ngrx';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { User } from '@app/core/models';
import { MyNotificationsService, NotificationService } from '@app/core/services';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '@app/shared/components';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'ecp-frame-to-come',
  templateUrl: './frame-to-come.component.html',
  styleUrls: ['./frame-to-come.component.scss'],
})
export class FrameToComeComponent implements OnInit {
  public user$: Observable<any>;
  public userProfile$: Observable<User>;
  public notifications$: Observable<any>;

  frameToShip: any = [];
  frameToComeId: any = null;
  isFromDetails: any = false;
  frameOrder$: Subscription;
  frameDetails$: Observable<any>;
  cartId: any;
  dialogRef: any;
  pageLoading: boolean = false;

  constructor(
    private store: Store<AppState>,
    private _activeRoute: ActivatedRoute,
    private notificationService: NotificationService,
    private myNotificationsService: MyNotificationsService,
    private router: Router,
    private dialog: MatDialog,
  ) {
    this.userProfile$ = this.store.pipe(select(selectProfile));
    this.userProfile$.subscribe(user => {
      if (user.token) {
        window.localStorage.setItem('token', user.token);
        this.store.dispatch({
          type: MyNotificationsActionTypes.LOAD_MY_NOTIFICATIONS,
          programKey: user.program.programKey
        });
      }
    });
  }

  ngOnInit(): void {
    this.user$ = this.store.pipe(select(state => state.user));
    this.notifications$ = this.store.pipe(select(state => state.myNotifications));
    this.notifications$.pipe().subscribe((notifications: any) => {
      if (notifications && !notifications.acknowledge) {
        try {
          let notificationOptions = {
            title: 'Notification',
            contentHtml: notifications.list.htmlContent,
            confirmBtnText: 'Acknowledged',
            buttonClicked: () => {
              this.store.dispatch({
                type: MyNotificationsActionTypes.PATCH_MY_NOTIFICATIONS,
              });
            },
          };
          this.notificationService.error(notificationOptions);
          this.myNotificationsService.notifiedFlag = true;
        } catch (e) {
          //do nothing
        }
      }
    });
    this.frameToComeDetails();
  }
  emitLoading(isLoading:any){
    this.pageLoading = isLoading;
  }

  frameToComeDetails() {
    this.frameToComeId = this._activeRoute.snapshot.params?.cartId || '';
    if (this.frameToComeId) {
      this.store.dispatch({
        type: FrameToComeActionTypes.LOAD_FRAME_TO_COME,
        payload: this.frameToComeId,
      });
    } else {
      this.store.dispatch({
        type: FrameToComeActionTypes.CLEAR_FRAME_TO_COME,
      });
      this.store.dispatch({
        type: FrameToComeActionTypes.LOAD_FRAME_TO_COME_ORDERS,
      });
      this.frameOrder$ = this.store.select(selectFrameToComeOrder).subscribe(activeCart => {
        if (activeCart.orders.length !== 0) {
          this.pendingDialog();
          this.pageLoading = true;
        }
      });
    }
    this.store.select(selectFrameToCome).subscribe(frame => {
      if (frame) {
        this.frameToShip = frame?.frameItems;
        this.cartId = frame?.cartId;
      }
    });
  }
  pendingDialog() {
    if (this.dialogRef) return;
    this.dialogRef = this.dialog
      .open(ConfirmDialogComponent, {
        disableClose: true,
        width: '600px',
        maxWidth: '89.3vw',
        maxHeight: '82vh',
        data: {
          content: `You are opening a new shipping box. You will not be able to add more frames to the old box once you open a new box.`,
          title: `Create New`,
          confirmBtnText: 'Ok',
          cancelBtnText: 'Cancel',
        },
      })
      .afterClosed()
      .subscribe(res => {
        this.pageLoading = false;
        if (!res) {
          this.router.navigateByUrl('/frame-to-come/track-shipment');
        }
      });
  }
  backToList() {
    this.router.navigateByUrl('/frame-to-come/track-shipment');
  }
  ngOnDestroy() {
    if (this.frameOrder$) {
      this.frameOrder$.unsubscribe();
    }
  }
}
